import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-explore-five-section',
  templateUrl: './explore-five-section.component.html',
  styleUrls: ['./explore-five-section.component.scss']
})
export class ExploreFiveSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
